import { combineReducers } from "redux";
import {
  customers_reducer,
  customer_reducer,
  get_marketing_reducer,
  get_prods_from_excel_reducer,
  marketing_reducer,
  orders_reducer,
  origins_reducer,
  products_reducer,
  sync_data_reducer,
  upload_excel_reducer,
} from "./actions/admin/Reducer";
import {
  customer_activate_reducer,
  forgot_password_reducer,
  register_reducer,
  reset_password_reducer,
  sessions_reducer,
  upload_img_reducer,
} from "./actions/auth";
import {
  delete_from_cart_reducer,
  get_orders_reducer,
  get_order_reducer,
  get_prod_filters_reducer,
  get_profoma_doc_reducer,
  order_add_comments_reducer,
  order_history_reducer,
  order_repeat_reducer,
  update_cart_reducer,
  update_order_reducer,
  update_profoma_doc_reducer,
} from "./actions/orders";
import {
  add_to_cart_reducer,
  create_order_reducer,
  get_addresses_reducer,
  get_cart_reducer,
  get_products_reducer,
  get_regions_reducer,
  order_get_comments_reducer,
  storedOrder_reducer,
} from "./actions/orders/Reducer";

export default combineReducers({
  auth: combineReducers({
    register: register_reducer,
    sessions: sessions_reducer,
    forgot_password: forgot_password_reducer,
    reset_password: reset_password_reducer,
    // dashboard: dashboard_reducer,
  }),
  orders: combineReducers({
    addresses: get_addresses_reducer,
    regions: get_regions_reducer,
    products: get_products_reducer,
    storedOrder: storedOrder_reducer,
    addToCart: add_to_cart_reducer,
    cart: get_cart_reducer,
    createOrder: create_order_reducer,
    delFromCart: delete_from_cart_reducer,
    all: get_orders_reducer,
    single: get_order_reducer,
    update_cart: update_cart_reducer,
    product_filters: get_prod_filters_reducer,
    update_order: update_order_reducer,
    order_history: order_history_reducer,
    order_repeat: order_repeat_reducer,
    order_add_comments: order_add_comments_reducer,
    order_get_comments: order_get_comments_reducer,
    profoma_doc: get_profoma_doc_reducer,
    update_profoma_doc: update_profoma_doc_reducer,
  }),
  admin: combineReducers({
    orders: orders_reducer,
    origins: origins_reducer,
    products: products_reducer,
    customers: customers_reducer,
    customer_activate: customer_activate_reducer,
    uploadImg: upload_img_reducer,
    get_customer: customer_reducer,
    prods_from_excel: get_prods_from_excel_reducer,
    upload_excel: upload_excel_reducer,
    sync_omni_data: sync_data_reducer,
    marketing: marketing_reducer,
    get_marketing: get_marketing_reducer,
  }),
});
